var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service-container-wrapper"},_vm._l((_vm.filtered),function(service){return _c('service-container',{key:service.title,attrs:{"service":service}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }